const hexToRgb = raw => {
  let hex = raw.substring(1);

  if (hex.length === 3) {
    hex = hex.split('').map(char => `${char}${char}`).join('');
  }

  const colors = hex.match(/.{1,2}/g);
  return colors.map(color => parseInt(color, 16));
};

export default hexToRgb;
